module.exports = __webpack_public_path__ + "img/food_tray_service.bfd7a450.png";